import React, { useContext, useEffect, useState } from 'react'
import { DarkModeContext } from '../../global/Theme'
import { useSelector, useDispatch } from 'react-redux'
import ConnectionCard from './ConnectionCard'
import { useHistory } from 'react-router-dom';
import { isFollowed, followUser, unFollowUser } from '../../api/social';
import { initMessage } from '../../api/chat';
import { CopyToClipboard } from 'react-copy-to-clipboard';


export default function ProfileCardViewer({ userDataStore }) {
    const { isDark } = useContext(DarkModeContext);
    const [followed, setFollowed] = useState(0);
    const history = useHistory()
    const user = useSelector(state => state.userState.id)
    const dispatch = useDispatch()


    const getIsFollowed = async () => {
        const res = await isFollowed(userDataStore);
        if (res) setFollowed(1)
        else setFollowed(2);
    }

    useEffect(() => {
        getIsFollowed();
    }, [])

    const handleSubscribe = async () => {
        if (followed == 2) {
            await followUser(userDataStore.id);
            getIsFollowed();
        } else if (followed == 1) {
            await unFollowUser(userDataStore.id);
            getIsFollowed();
        }
    }

    const handleInitMessage = async () => {
        if (user != null) {
            console.log("INITIATING")
            const channelID = await initMessage(user, userDataStore.id)
            document.getElementById('mobileNav').style.display = 'flex';
            history.push('/message', {remoteID: userDataStore.id, channelID: channelID})
        }
    }

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    return (
        <div id="profileCard">
            <div id="profileCardInfo">
                <div id="profileInfoLeft">
                    <h1>{userDataStore.followersCount}</h1>
                    <p>Lovrs</p>
                </div>
                <div id="profileInfoDP">
                    <img src={(userDataStore.image === "") ? (userDataStore.isCreator) ? require("../../assets/icons/creator.svg") : require("../../assets/icons/viewer.svg") : userDataStore.image} />
                </div>
                <div id="profileInfoRight">
                    <h1>{userDataStore.followingCount}</h1>
                    <p>Loving</p>
                </div>
            </div>

            <div id="profileCardDetails">
                <div id="profileCardName">
                    <p className={`${isDark ? 'p-dark' : 'p-light'}`}>{userDataStore.name}</p>
                    <CopyToClipboard text={`https://lovr.online/user/${userDataStore.username}`}
                        onCopy={async () => {
                            dispatch({
                                type: 'SET_NOTIFICATION', payload: {
                                    isEnabled: true,
                                    text: 'Link copied to Clipboard',
                                    icon: 'notifcomment.svg'
                                }
                            })
                            await sleep(3000)
                            dispatch({
                                type: 'SET_NOTIFICATION', payload: {
                                    isEnabled: false,
                                    text: '',
                                    icon: ''
                                }
                            })
                        }}>
                        <img src={require('../../assets/icons/pshare.svg')} />

                    </CopyToClipboard>
                </div>
                <div id="profileDescription">
                    <p>{userDataStore.bio}</p>
                </div>

                {userDataStore.isCreator && <div id="editProfileBtn" onClick={handleSubscribe}>
                    <div style={{ width: 'max-content', padding: '0 16px' }}>
                        {followed != 0 ? followed == 2 ? <p >Subscribe for {`${userDataStore.price}`}$ per month</p> : <p>Subscribed</p> : null}
                    </div>
                </div>}

                <div onClick={handleInitMessage} className="message-button">
                    <div>
                        <p>Message</p>
                    </div>
                </div>

                <div className={isDark ? 'profile-connection-card-dark' : 'profile-connection-card'} id='profile-connection-card'>
                    <img src={require('../../assets/icons/url.svg')} />
                    <p>Connections</p>
                </div>

                <div className="profile-connection-row">
                    <ConnectionCard type="website" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.website.length > 0) ? true : false} img='website.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.website.length > 0) ? userDataStore.socialMedia.website : "#"} />
                    <ConnectionCard type="instagram" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.instagram.length > 0) ? true : false} img='instagram.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.instagram.length > 0) ? userDataStore.socialMedia.instagram : "#"} />
                </div>
                <div className="profile-connection-row">
                    <ConnectionCard type="spotify" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.spotify.length > 0) ? true : false} img='spotify.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.spotify.length > 0) ? userDataStore.socialMedia.spotify : "#"} />
                    <ConnectionCard type="tiktok" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.tiktok.length > 0) ? true : false} img='tiktok.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.tiktok.length > 0) ? userDataStore.socialMedia.tiktok : "#"} />
                </div>
                <div className="profile-connection-row">
                    <ConnectionCard type="pornhub" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.pornhub.length > 0) ? true : false} img='pornhub.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.pornhub.length > 0) ? userDataStore.socialMedia.pornhub : "#"} />
                    <ConnectionCard type="snapchat" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.snapchat.length > 0) ? true : false} img='snapchat.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.snapchat.length > 0) ? userDataStore.socialMedia.snapchat : "#"} />
                </div>
                <div className="profile-connection-row">
                    <ConnectionCard type="twitter" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.twitter.length > 0) ? true : false} img='twitter.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.twitter.length > 0) ? userDataStore.socialMedia.twitter : "#"} />
                    <ConnectionCard type="twitch" isActive={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.twitch.length > 0) ? true : false} img='twitch.png' page={(userDataStore.socialMedia != undefined && userDataStore.socialMedia.twitch.length > 0) ? userDataStore.socialMedia.twitch : "#"} />
                </div>
            </div>
        </div>

    )
}
